/**
 * Created by Ivan on 27.09.2025
 */

const RaveReviewsWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this._super({
            name: "RaveReviewsWindow",
            noBorder: cleverapps.styles.RaveReviewsWindow.noBorder,
            title: Messages.get(cleverapps.raveReviews.isCompleted() ? "RaveReviewsWindow.title2" : "RaveReviewsWindow.title"),
            content: this.createContent(),
            foreground: bundles.rave_reviews_window.frames.window_foreground
        });

        cleverapps.raveReviews.on("updateState", this.onUpdateState.bind(this), this);
    },

    onUpdateState: function () {
        this.bar.setPercentage(cleverapps.raveReviews.calcPoints(), { animated: true });
    },

    createContent: function () {
        const styles = cleverapps.styles.RaveReviewsWindow;

        const content = this.content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(styles);

        this.createBg();
        this.createBar();
        this.createText();
        this.createButton();

        return content;
    },

    createBg: function () {
        const styles = cleverapps.styles.RaveReviewsWindow.bg;

        const bg = new cc.Sprite(bundles.rave_reviews_window.frames.w_prize_bg);
        this.content.addChild(bg);
        bg.setAlignment(styles);
    },

    createBar: function () {
        const styles = cleverapps.styles.RaveReviewsWindow.bar;
        const bar = new ScaledProgressBar({
            progress: bundles.rave_reviews_window.frames.w_bar_green_medium,
            background: bundles.rave_reviews_window.frames.w_bg_green_medium,
            barText: {
                font: cleverapps.styles.FONTS.RAVE_REVIEWS_BAR_TEXT,
                dy: styles.dy
            }
        });
        this.bar = bar;
        bar.setLength(styles.width);
        bar.setGoal(cleverapps.raveReviews.calcGoal());
        bar.setPercentage(cleverapps.raveReviews.calcPoints());
        this.content.addChild(bar);
        bar.setAlignment(styles);

        const gift = new cc.Sprite(bundles.rave_reviews_window.frames.w_prize_box);
        bar.addChild(gift);
        gift.setAlignment(styles.gift);
        cleverapps.UI.onClick(gift, this.createTooltip.bind(this));

        const giftAttention = new cc.Sprite(bundles.rave_reviews_window.frames.tooltip_attention);
        gift.addChild(giftAttention);
        giftAttention.setAlignment(styles.gift.attention);

        const icon = new cc.Sprite(bundles.rave_reviews_window.frames.w_progress_bar_icon);
        bar.addChild(icon);
        icon.setAlignment(styles.icon);

        if (cleverapps.config.debugMode) {
            cleverapps.UI.onClick(icon, () => {
                if (!cleverapps.raveReviews.isCompleted()) {
                    cleverapps.raveReviews.addPoints(1);
                }
            }, {
                onDoubleClick: () => {
                    const remainingPoints = cleverapps.raveReviews.calcGoal() - cleverapps.raveReviews.calcPoints();
                    if (!remainingPoints) {
                        return;
                    }
                    cleverapps.raveReviews.addPoints(remainingPoints);
                },
                interactiveScale: false
            });
        }
    },

    createText: function () {
        const styles = cleverapps.styles.RaveReviewsWindow.text;
        const label = cleverapps.UI.generateOnlyText(Messages.get(cleverapps.raveReviews.isCompleted()
            ? "RaveReviewsWindow.completeText"
            : "RaveReviewsWindow.text"), cleverapps.styles.FONTS.RAVE_REVIEWS_TEXT);
        label.setDimensions(styles.width, 0);
        label.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        label.fitTo(undefined, styles.height);
        this.content.addChild(label);
        label.setAlignment(styles);
    },

    createButton: function () {
        const styles = cleverapps.styles.RaveReviewsWindow.button;
        const button = this.button = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            text: Messages.get(cleverapps.raveReviews.isCompleted() ? "Claim" : "OK"),
            onClicked: () => {
                this.close();
                cleverapps.raveReviews.checkReward();
            }
        });
        this.content.addChild(button);
        button.setAlignment(styles);
    },

    createTooltip: function () {
        if (this.tooltip) {
            return;
        }

        const styles = cleverapps.styles.RaveReviewsWindow.tooltip;

        const tooltip = this.tooltip = new cc.Sprite(bundles.rave_reviews_window.frames.w_prize_tooltip);
        this.content.addChild(tooltip);
        tooltip.setAlignment(styles);

        const title = cleverapps.UI.generateOnlyText(Messages.get("RaveReviewsWindow.tooltipTitle"), cleverapps.styles.FONTS.RAVE_REVIEWS_TOOLTIP_TITLE_TEXT);
        tooltip.addChild(title);
        title.setAlignment(styles.title);
        title.fitTo(styles.title.width);

        const text = cleverapps.UI.generateOnlyText(Messages.get("RaveReviewsWindow.tooltip"), cleverapps.styles.FONTS.RAVE_REVIEWS_TOOLTIP_TEXT);
        tooltip.addChild(text);
        text.setAlignment(styles.text);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.text.width);
        text.fitTo(undefined, styles.text.height);

        cleverapps.inputDispatcher.on("pointerdown", () => {
            if (this.tooltip) {
                this.tooltip.removeFromParent();
                this.tooltip = undefined;
            }
        }, this);
    },

    listBundles: function () {
        return ["rave_reviews_window"];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RAVE_REVIEWS_BAR_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    },

    RAVE_REVIEWS_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    RAVE_REVIEWS_TOOLTIP_TEXT: {
        size: 28,
        color: cleverapps.styles.COLORS.WHITE
    },

    RAVE_REVIEWS_TOOLTIP_TITLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.YELLOW,
        stroke: cleverapps.styles.DECORATORS.RED_STROKE
    }
});

cleverapps.styles.RaveReviewsWindow = {
    width: 765,
    height: 1015,

    bg: {
        x: { align: "center" },
        y: { align: "center", dy: 8 }
    },

    bar: {
        width: 600,
        x: { align: "center" },
        y: { align: "top", dy: -40 },

        gift: {
            x: { align: "right", dx: 70 },
            y: { align: "center", dy: 20 },
            attention: {
                x: { align: "right", dx: 7 },
                y: { align: "top", dy: -32 }
            }
        },

        icon: {
            x: { align: "left", dx: -45 },
            y: { align: "center", dy: 6 }
        },

        dy: 2
    },

    text: {
        width: 600,
        height: 100,
        x: { align: "center" },
        y: { align: "bottom", dy: 115 }
    },

    button: {
        width: 300,
        height: 90,
        x: { align: "center" },
        y: { align: "bottom" }
    },

    tooltip: {
        x: { align: "right", dx: 51 },
        y: { align: "center", dy: 267 },

        text: {
            x: { align: "center", dx: 100 },
            y: { align: "center", dy: -20 },
            width: 320,
            height: 150
        },

        title: {
            width: 300,
            x: { align: "center", dx: 100 },
            y: { align: "center", dy: 60 }
        }
    }
};
